export default __webpack_public_path__ + "static/media/News-1.383c4bb9.jpg";